import axios from "../axios/axios-kaqadmin";
import {useBearerTokenHeaders} from "../utils/functions";

export const financialSheetService = {
    generateFinancialSheet,
    downloadFinancialSheet,
    generateMonthlyClosing,
    getGeneratedMonthlyClosing,
    generateMonthlyResult,
    getGeneratedMonthlyResult,
    downloadFinancialComponent,
    fetchFAdminDownloadProgress
}


function generateFinancialSheet(payload){
    return new Promise((resolve, reject) => {
        axios.post('/f-admin/generate-financial-sheet', payload, useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}
function downloadFinancialSheet(payload){
    return new Promise((resolve) => {
        axios.post('/f-admin/download-financial-sheet', payload, useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}

function downloadFinancialComponent(payload){
    return new Promise((resolve) => {
        axios.post('/f-admin/download-financial-component', payload, useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}

function generateMonthlyClosing(payload){
    return new Promise((resolve, reject) => {
        axios.post('/f-admin/monthly-closing', payload, useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}

function getGeneratedMonthlyClosing(){
    return new Promise((resolve) => {
        axios.get('/f-admin/get-generated-monthly-closing', useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}

function generateMonthlyResult(payload){
    return new Promise((resolve, reject) => {
        axios.post('/f-admin/monthly-result', payload, useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}

function getGeneratedMonthlyResult(){
    return new Promise((resolve) => {
        axios.get('/f-admin/get-generated-monthly-result', useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}

function fetchFAdminDownloadProgress(token){
    return new Promise((resolve) => {
        axios.get(`/f-admin/fetch-fadmin-download-progress/${token}`, useBearerTokenHeaders() )
            .then(response => {
                resolve(response.data)
            }).catch(err => resolve({status: false, message: err}));
    })
}
